import { makeStyles, DialogActions, DialogTrigger, Button } from '@fluentui/react-components';
import React from 'react';
const useStyles = makeStyles({
  deleteButton: {
    backgroundColor: '#bf0000',
    ':hover': {
      backgroundColor: '#b00000',
    },
  },
});
export function AppEditDialogActions(props: {
  onCancel: () => void;
  onSubmit: () => void;
  submitDisabled: boolean;
  showDelete?: boolean;
}) {
  const styles = useStyles();

  return (
    <DialogActions>
      <DialogTrigger>
        {props.showDelete ? (
          <Button
            appearance="primary"
            className={styles.deleteButton}
            onClick={props.onSubmit}
            disabled={props.submitDisabled}
          >
            Delete
          </Button>
        ) : (
          <Button appearance="primary" onClick={props.onSubmit} disabled={props.submitDisabled}>
            Save
          </Button>
        )}
      </DialogTrigger>
      <DialogTrigger>
        <Button appearance="secondary" onClick={props.onCancel}>
          Cancel
        </Button>
      </DialogTrigger>
    </DialogActions>
  );
}
